export default {
    fields: {
        productName: 'Наименование товара',
        sku: 'Локальный код товара',
        barcode: 'Штрихкод товара',
        skuQuantity: 'Заказано клиентом / Резерв',
        skuQuantityAdaptive: 'Заказано/ Собрано',
        skuQuantityFinished: 'Собрано',
        productPrice: 'Цена за шт., %currencyAbbreviation%',
        productSumPrice: 'Сумма, %currencyAbbreviation%',
        productCommentCooperator: 'Комментарий к позиции колл-центра',
        productCommentWorker: 'Комментарий к позиции сотрудника магазина',
        productProperties: 'Характеристики товара',
        productCommentClient: 'Комментарий к позиции',
        pic: 'Изображение',
        actions: 'Подтвердить изменения',
        refundQuantity: 'Возвращаемое количество товара',
        totalRefundPrice: 'Итоговая сумма возврата за товарную позицию',
        productWeight: 'Вес',
        exchangeQuantity: 'Количество товара для обмена',
        refundSkuQuantityFinished: 'Количество товара, проданное клиенту',
        exchangeSkuQuantityFinished: 'Количество товара, проданное клиенту',
    },

    productsTable: {
        span: [
            'Заказано покупателем (товары):',
            '[Оплачено]',
            'Итого собрано (товары):',
            'Стоимость доставки',
            'Скидка по акции:',
            'Стоимость пакета:',
            'Итого собрано (с учетом пакета):',
            'Итого к оплате:',
            'Скидка по промокоду:',
        ],
        totalText: 'Итого собрано (с учетом доставки):',
        totalWithDiscount: 'Итого собрано (с учетом скидки и доставки):',
        totalWithPackages: 'Итого собрано (с учетом пакетов и доставки)',
        totalWithDicountAndPackages: 'Итого собрано (с учетом скидки, доставки и пакетов)',
        totalPayable: 'Итого к оплате:',
        titleProducts: 'Состав заказа',
        totalTitle: 'Итоговая информация',
        pointsWrittenOffTitle: 'Списано баллов:',
        bonusTitle: 'Программа лояльности',
        bonusDelta: 'Начислено/списано баллов за покупку:',
        bonusActivePoints: 'Активные баллы:',
        bonusInactivePoints: 'Неактивные баллы:',
        bonusUpdateTime: 'Дата последнего обновления статуса бонусного счета:',
    },

    skuQuantityTare: 'Добавьте | упаковочную тару | Количество | Добавить',
    add: 'Добавить',
    finished: 'Собрано',
    markScanning: 'Сканирование марки',

    // eslint-disable-next-line max-len
    addToTareExceptions: 'Некорректные данные в запросе, попробуйте обновить страницу нажав на иконку обновления или клавишу F5 на клавиатуре. Если проблема не исчезнет, просьба обратиться в поддержку',
};